/* eslint-disable @typescript-eslint/lines-between-class-members */
export default class ContentTypes {
    static readonly ApplicationJson = 'application/json';

    // images
    static readonly ImageWebp = 'image/webp';
    static readonly ImageJpeg = 'image/jpeg';
    static readonly ImagePng = 'image/png';
}
